export enum LocalStorageEnum {
  ACCOUNTS = 'kadroAccounts',
}
